import { DUMP_STATION_ICON } from '@cnt-workspace/data-access';

/**
 * Inline SVG for icon names that aren't Material Symbols ligatures. Each glyph
 * sits on the same 24px grid as Material Symbols, is filled with currentColor
 * and sized 1em, so it takes the size and color of the span it replaces.
 */
export const CUSTOM_SYMBOLS: Readonly<Record<string, string>> = {
  [DUMP_STATION_ICON]:
    '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" style="display:block">' +
    '<path d="M3.25 7.5H9.5V10H7v8.5h10V10h-2.5V7.5h6.25a1.25 1.25 0 0 1 0 2.5H19.5v9.5a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5V10H3.25a1.25 1.25 0 0 1 0-2.5z"/>' +
    '<path d="M10.75 3.25a1.25 1.25 0 0 1 2.5 0V11h1.85a.9.9 0 0 1 .7 1.5l-3.1 3.7a.9.9 0 0 1-1.4 0l-3.1-3.7a.9.9 0 0 1 .7-1.5h1.85z"/>' +
    '</svg>',
};

/** Markup for an icon inside an HTML string (e.g. a Leaflet divIcon): the
 *  custom SVG when there is one, otherwise the escaped ligature name for a
 *  Material Symbols span. */
export function symbolHtml(name: string): string {
  return CUSTOM_SYMBOLS[name] ?? name.replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
}
